import useSWR from "swr";
import { dialogInterface } from "src/data/interfaces";

export function useDialog() {
    return useSWR<dialogInterface, any>("dialog", async () => {
        return {};
    });
}
